/** Client id for the synthetic general tab (no DB row). */
export const PASSPORT_BUILDER_SYNTHETIC_TAB_ID = 'pb-tab-general'

/** Fallback label for the synthetic general tab (UI uses `itf.passport_builder_general_tab`). */
export const PASSPORT_BUILDER_GENERAL_TAB_LABEL = 'General information'
